<script>
	import { PRConnect } from "@projectroom/ui-lib";
	import axios from "axios";
	import "suneditor/dist/css/suneditor.min.css";
	import suneditor from "suneditor";
	import plugins from "suneditor/src/plugins";
	import lang from "suneditor/src/lang";

	export let event;

	let refResultMainImageContent;
	const refEditor = {
		content: {},
		notice: {},
	};

	$: if (
		event.currentTab === "announcementResult" &&
		event.isLoad &&
		Object.keys(refEditor.content).length === 0
	) {
		setEditor("content", "event-result-content", event.resultContent);
		setEditor("notice", "event-result-notice", event.resultNotice);
	}

	const onResultMainImageContentFileUpload = (e) => {
		let image = e.target.files[0];
		const key = `common/event/${event.id}/detail/${image.name}`;
		const type = image.type;
		PRConnect.send(
			"/api/File/uploadPresignedUrl",
			{ key, type },
			(data) => {
				axios
					.put(data.result, image, {
						headers: { "Content-Type": type },
					})
					.then((response) => {
						event.changeResultMainImageContent(image.name);
						event = event;
					});
			},
		);
	};

	const clickReulstMainImageDelete = () => {
		event.deleteResultMainImageContent();
		event = event;
	};

	const setEditor = (refTarget, targetId, content) => {
		let editor;
		editor = suneditor.create(targetId);
		editor.setDefaultStyle("font: Notosanskr; font-size: 10px;");
		editor.setOptions({
			defaultStyle:
				"font-size:14px;font-family: Notosanskr, sans-serif;font-weight:400;",
			minHeight: "300px",
			width: "100%",
			plugins: plugins,
			placeholder: "상세정보를 입력해주세요. (사진첨부 가능)",
			showPathLabel: false,
			lang: lang.ko,
			buttonList: [
				["undo", "redo"],
				["fontSize"],
				["bold", "underline"],
				["fontColor", "removeFormat"],

				["horizontalRule", "list"],
				["link", "image"],
				["fullScreen", "preview"],
			],
		});
		editor.setContents(content);
		editor.onImageUpload = async (
			targetElement,
			index,
			state,
			info,
			remainingFilesCount,
			core,
		) => {
			let fileSrc;
			let fileType;
			try {
				fileSrc = info.src;
				fileType = info.src.split("data:")[1].split(";")[0];
			} catch {
				console.log("stored image load error");
				return;
			}
			targetElement.src = `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/event/${event.id}/detail/${info.name}`;
			const res = await fetch(fileSrc);
			const blob = await res.blob();
			const uploadFile = new File([blob], info.name, { type: fileType });
			uploadFileForFileStorage(uploadFile, editor);
		};
		refEditor[refTarget] = editor;
	};

	const onMouseLeave = (editor) => {
		if (editor === "content") {
			event.changeResultContent(refEditor[editor].getContents());
		} else {
			event.changeResultNotice(refEditor[editor].getContents());
		}
	};
</script>

<div
	data-w-tab="Tab 4"
	class="w-tab-pane"
	class:w--tab-active={event.currentTab === "announcementResult"}
>
	{#if event.isLoad}
		<div class="event-thumbnail-write-wrap">
			<div class="event-write">
				<div class="admin-title-text _2">결과 발표 작성</div>
				<div class="event-main-image">
					<div class="admin-title-text">메인 이미지</div>
					<div class="event-thumbnail-image">
						{#if event.getResultMainImageContent()}
							<img
								class="main-image-content"
								src={event.getResultMainImageContent()}
							/>
							<img
								loading="lazy"
								src="/static/images/trashcan-icon.svg"
								class="logo-image-delete"
								on:click={clickReulstMainImageDelete}
							/>
						{:else}
							<img
								src="https://uploads-ssl.webflow.com/6305dccb2939dad9c631e36f/64b7852fd75bbfcf43e8d2b1_upload-icon-big.svg"
								loading="lazy"
								alt=""
								class="image-153"
							/>
							<div>
								<a
									href="#"
									class="image-upload-button w-button"
									on:click={refResultMainImageContent.click()}
									>메인 이미지 업로드</a
								>
								<input
									accept="image/png, image/jpeg, image/jpg"
									bind:this={refResultMainImageContent}
									type="file"
									name="add"
									on:change={onResultMainImageContentFileUpload}
									hidden
								/>
							</div>
						{/if}
					</div>
				</div>
				<div class="event-infomation-text">
					<div class="admin-title-text">결과 발표 텍스트</div>
					<div class="linktext-block-form">
						<div class="text-block-94">결과 발표 안내글</div>
						<div
							class="linktext-input-form-copy w-form"
							on:mouseleave={() => onMouseLeave("content")}
						>
							<div
								id="email-form"
								name="email-form"
								data-name="Email Form"
								method="get"
								class="contents-con"
							>
								<textarea id="event-result-content"></textarea>
							</div>
						</div>
					</div>
				</div>
				<div class="event-note-text">
					<div class="admin-title-text">
						결과 발표 유의사항 텍스트
					</div>
					<div class="linktext-block-form">
						<div class="text-block-94">
							결과 발표 유의사항 관련 안내글
						</div>
						<div
							class="linktext-input-form-copy w-form"
							on:mouseleave={() => onMouseLeave("notice")}
						>
							<div
								id="email-form"
								name="email-form"
								data-name="Email Form"
								method="get"
								class="contents-con"
							>
								<textarea id="event-result-notice"></textarea>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	{/if}
</div>

<style>
	.main-image-content {
		width: 300px;
		border-radius: 10px;
		height: -webkit-fill-available;
	}

	.event-thumbnail-image {
		position: relative;
	}

	.logo-image-delete {
		right: 15px;
		top: 15px;
		position: absolute;
		cursor: pointer;
	}
	.image-153 {
		margin-top: 0px;
		margin-left: 0px;
	}
</style>
